module.exports = __webpack_public_path__ + "home-solid-d20cd1f09be308ac0a47.svg";